// Bridges the Keycloak instance (held in React state by KeycloakProvider) to
// non-React modules such as the axios client. The provider registers the live
// instance here; the axios request interceptor reads/refreshes the token from it.

let keycloakRef: any = null;

/** Called by KeycloakProvider once Keycloak is initialized. */
export const registerKeycloak = (instance: any): void => {
  keycloakRef = instance;
};

/** Current access token, or undefined if unauthenticated. */
export const getToken = (): string | undefined => keycloakRef?.token;

/**
 * Returns a still-valid access token, refreshing it first if it expires within
 * `minValidity` seconds. Never throws — returns undefined if refresh fails or
 * there is no authenticated session.
 */
export const getFreshToken = async (minValidity = 30): Promise<string | undefined> => {
  if (!keycloakRef || !keycloakRef.token) return undefined;
  try {
    await keycloakRef.updateToken(minValidity);
  } catch {
    // refresh failed (e.g. SSO session expired) — caller falls back to no header
  }
  return keycloakRef.token;
};
